angular.module('ffApp').config(['$compileProvider', function($compileProvider)
{
	$compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|spotify):/);
}]);